import { render, staticRenderFns } from "./MediakitPropertyCard.vue?vue&type=template&id=44f97d88&scoped=true&"
import script from "./MediakitPropertyCard.vue?vue&type=script&lang=js&"
export * from "./MediakitPropertyCard.vue?vue&type=script&lang=js&"
import style0 from "./MediakitPropertyCard.vue?vue&type=style&index=0&id=44f97d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f97d88",
  null
  
)

export default component.exports